// extracted by mini-css-extract-plugin
export default {"root":"ReportErrorPageContainer_root__m7aFO"};